/**
 * Keep a voice call open while the person is busy on another screen for it.
 *
 * Approving a supplier order takes them to the passkey page for a minute or
 * two. On Tom's first real voice order (3 Nov 2026) Mucka asked "Still
 * there?", heard a "No." meant for nobody, said goodnight and ended the call,
 * and the order then ran with nobody on the line to hear how it went.
 *
 * The order card sets a hold when Approve is tapped and lifts it when the
 * order ends; the web engine's end_session refuses while it stands. (A native
 * call decides end_session inside the app binary, so there the order tool's
 * own result is what tells the agent not to: supplierOrderToolNote.)
 */

let heldUntil = 0;
let why = '';

export function holdCallOpen(ms: number, reason: string, now = Date.now()): void {
  heldUntil = now + ms;
  why = reason;
}

export function releaseCallHold(): void {
  heldUntil = 0;
  why = '';
}

/** The reason the call must stay open, or null when nothing is holding it. */
export function callHoldReason(now = Date.now()): string | null {
  return now < heldUntil ? why : null;
}
